import {FC} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import {SearchSelectBox as JbcSearchSelectBox} from 'jbc-front/components/SearchForm'

interface SearchSelectBoxProps {
  name: string
  options: {value: string; label: string}[]
  width?: number
  placeholder?: string
  clearable?: boolean
  shouldUnregister?: boolean
}

export const SearchSelectBox: FC<SearchSelectBoxProps> = ({
  name,
  options,
  width,
  placeholder,
  clearable = false,
  shouldUnregister = false,
}) => {
  const {control} = useFormContext()
  const {field} = useController({name, control, shouldUnregister})

  return (
    <JbcSearchSelectBox
      input={{
        value: field.value,
        onChange: field.onChange,
        onBlur: field.onBlur,
      }}
      options={options}
      width={width}
      placeholder={placeholder}
      clearable={clearable}
      onSelect={() => {}}
    />
  )
}
